import { queryProfileIdCardApi } from '@eastcoal/api/auth/profile/queryProfileIdCard'

import { onFieldValueChange } from '@eastcoal/formily/exports/core'

export const agentOssIdEffect = () => {
  onFieldValueChange('*(agentId,legalPersonIdNumber)', async (_, form) => {
    if (!(form.values.agentId && form.values.legalPersonIdNumber)) {
      form.setFieldState('agentOssId', state => {
        state.required = false
      })
      return
    }
    const agentIdNumber = await queryProfileIdCardApi({
      profileId: form.values.agentId
    })
    form.setFieldState('agentOssId', state => {
      state.required = agentIdNumber === form.values.legalPersonIdNumber
    })
  })
}
